// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/~/core-js/modules/_is-array.js
// module id = 110
// module chunks = 0